import * as angular from 'angular';

import { ComponentDefinition, JustificationLevel, KeyValuePair } from '../../models/index';

class JustificationLevelPickerController implements angular.IComponentController {
    static $inject = [];

    levels: KeyValuePair<JustificationLevel, string>[] = [
        { key: JustificationLevel.Never, value: 'Never' },
        { key: JustificationLevel.Always, value: 'Always' },
        { key: JustificationLevel.OnApproval, value: 'On approval' },
        { key: JustificationLevel.OnRejection, value: 'On rejection' }
    ];
}

export const wtJustificationLevelPicker: ComponentDefinition = {
    componentId: 'wtJustificationLevelPicker',
    controller: JustificationLevelPickerController,
    template: require('./justificationLevelPicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        name: '@',
        isDisabled: '<?',
        model: '='
    }
};